import Phaser from 'phaser';

export interface DamageNumberOptions {
  crit?: boolean;
  color?: string; // override de color (p.ej. daño al héroe, o texto de estado)
}

/**
 * Números de daño flotantes: aparecen sobre el objetivo, suben y se
 * desvanecen. Sin física ni pool complejo — solo texto + tween, se destruye
 * solo al terminar.
 */
export class DamageNumbers {
  constructor(
    private readonly scene: Phaser.Scene,
    private readonly container: Phaser.GameObjects.Container
  ) {}

  /** Número de daño (o 0 de forma excepcional) sobre un objetivo. */
  spawn(x: number, y: number, value: number, options: DamageNumberOptions = {}): void {
    const isCrit = options.crit ?? false;
    const color = options.color ?? (isCrit ? '#ffd166' : '#ffffff');
    this.spawnText(x, y, isCrit ? `${value}!` : `${value}`, color, isCrit);
  }

  /** Texto de estado libre (p.ej. "bloqueado", "falló") con la misma animación. */
  spawnText(x: number, y: number, text: string, color = '#ffffff', emphasis = false): void {
    const label = this.scene.add
      .text(x, y, text, {
        fontFamily: 'monospace',
        fontSize: emphasis ? '16px' : '12px',
        color,
        fontStyle: emphasis ? 'bold' : 'normal',
        stroke: '#1b1030',
        strokeThickness: 3,
      })
      .setOrigin(0.5)
      .setScale(0.3);
    this.container.add(label);

    // Pop de entrada: aparece con un rebote breve (más marcado en críticos),
    // luego se asienta a su tamaño final.
    const popScale = emphasis ? 1.3 : 1.1;
    this.scene.tweens.add({
      targets: label,
      scale: popScale,
      duration: 90,
      ease: 'Back.Out',
      onComplete: () => {
        this.scene.tweens.add({ targets: label, scale: popScale * 0.88, duration: 100, ease: 'Sine.Out' });
      },
    });

    // Física sutil: sube desacelerando (como si "flotara") con una leve
    // deriva lateral aleatoria, en vez de una línea recta hacia arriba.
    const driftX = x + Phaser.Math.Between(-9, 9);
    this.scene.tweens.add({
      targets: label,
      x: driftX,
      y: y - 28,
      duration: 650,
      ease: 'Cubic.easeOut',
    });
    this.scene.tweens.add({
      targets: label,
      alpha: 0,
      delay: 280,
      duration: 340,
      ease: 'Sine.easeIn',
      onComplete: () => label.destroy(),
    });
  }
}
